import React, { Fragment, useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { gestionService } from "../../../../_services/gestionLegal.service";
import { formatCapital } from "../../../../utils/utils";
import { setLoading } from "../../../../redux/Loading/actions";
import { useDispatch } from "react-redux";


export const Actuacion = ({ id }) => {
  const [actuacion, setActuacion] = useState("");
  const [datos, setDatos] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    const getData = async () => {
      try {
        dispatch(setLoading(true));
        let response = await gestionService.getActuacion(id);

        setActuacion(response);

        if (response.dato) {
          setDatos(JSON.parse(response?.dato));
        }
        dispatch(setLoading(false));
      }
      catch (err) {
        console.log("err", err);
        dispatch(setLoading(false));
      }
    };

    getData();

    return () => {
      setActuacion("");
    };
  }, []);


  const pathTo = `${actuacion?.imponible}_${actuacion?.recurso}/`;

  return (
    <Table striped bordered >
      <tbody>
        <tr>
          <td><b>Abogado</b></td>
          <td>{actuacion?.abogado} {actuacion?.codexterno ? `(${actuacion?.codexterno})` : ""}</td>
        </tr>
        <tr>
          <td><b>Fecha</b></td>
          <td>{actuacion?.fecha}</td>
        </tr>
        <tr>
          <td><b>Tipo</b></td>
          <td>{actuacion?.tipo_nombre}</td>
        </tr>
        {actuacion?.obs ? (
          <tr>
            <td><b>Observación</b></td>
            <td>{actuacion?.obs}</td>
          </tr>
        ) : ""}
        {datos?.length ? (
          datos.map((e, indx) => {
            return (
              <Fragment key={`${indx}`} >
                {e.caratula ? (
                  <tr>
                    <td><b>Carátula</b></td>
                    <td>{e.caratula}</td>
                  </tr>
                ) : ""}
                {e.nroexpte ? (
                  <tr>
                    <td><b>Nro de Expte</b></td>
                    <td>{e.nroexpte}</td>
                  </tr>
                ) : ""}
                {e.nrotit ? (
                  <tr>
                    <td><b>Nro de Título Ejecutivo</b></td>
                    <td>{e.nrotit}</td>
                  </tr>
                ) : ""}
                {e.juzgado ? (
                  <tr>
                    <td><b>Juzgado que interviene</b></td>
                    <td>{e.juzgado}</td>
                  </tr>
                ) : ""}
                {e.monto ? (
                  <tr>
                    <td><b>Monto</b></td>
                    <td>$ {formatCapital(e.monto)}</td>
                  </tr>
                ) : ""}
                {e.cp8480 || e.cp8480 === 0 ? (
                  <tr>
                    <td><b>Cumplimiento con pago de Bono Ley 8480</b></td>
                    <td>{e.cp8480 ? "SI" : "NO"}</td>
                  </tr>
                ) : ""}
                {e.cpantprv || e.cpantprv === 0 ? (
                  <tr>
                    <td><b>Cumplimiento con pago Anticipo Previsional</b></td>
                    <td>{e.cpantprv ? "SI" : "NO"}</td>
                  </tr>
                ) : ""}
                {e.periodos ? (
                  <tr>
                    <td><b>Períodos que abarca</b></td>
                    <td>{e.periodos}</td>
                  </tr>
                ) : ""}
                {e.tipomedida ? (
                  <tr>
                    <td><b>Tipo de Medida</b></td>
                    <td>{e.tipomedida}</td>
                  </tr>
                ) : ""}
                {e.resultado ? (
                  <tr>
                    <td><b>Resultado</b></td>
                    <td>{e.resultado}</td>
                  </tr>
                ) : ""}
                {e.notifsent ? (
                  <tr>
                    <td><b>Fecha de Notificación de Sentencia</b></td>
                    <td>{e.notifsent}</td>
                  </tr>
                ) : ""}
                {e.modo ? (
                  <tr>
                    <td><b>Modo</b></td>
                    <td>{e.modo}</td>
                  </tr>
                ) : ""}
                {e.valor ? (
                  <tr>
                    <td><b>Valor</b></td>
                    <td>{e.valor}</td>
                  </tr>
                ) : ""}
              </Fragment>
            );
          })
        )
          : ""}
        {actuacion?.documentos?.length ? (
          <tr>
            <td><b>Documentos</b></td>
            <td>
              <div className="d-flex justify-content-around flex-column">
                <ul style={{ listStyle: "initial", paddingLeft: 20 }}>
                  {actuacion?.documentos.map((e) => {
                    return (
                      <li key={e.documento}>
                        <a
                          href={"https://staticcontent.sannicolasciudad.gob.ar/images/gestion-deudas/" + pathTo + e.documento}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {e.documento}
                        </a>
                      </li>
                    );
                  }
                  )}
                </ul>
              </div>
            </td>
          </tr>
        ) : null}
      </tbody>
    </Table>
  );
};
